// 极速版的配置
export const qqnewslite = {
  openUrl: `qqnewslite://article_9527?nm=`,
  downloadUrl: 'http://dldir1.qq.com/NewsLite_apk/apk/TencentNewsLite_101298.apk',
  packageName: 'com.tencent.news.lite',
  downLogo: 'https://mat1.gtimg.com/news/2018QQcoupon/icon.png',
  wxAppId: 'wxda49abab5a1e0d12',
  appleStoreId: '1449467351',
  appName: '腾讯新闻极速版--百万金币派发中...'
}

// 主版的配置
export const qqnews = {
  openUrl: `qqnews://article_9527?nm=`,
  wxAppId: 'wx073f4a4daff0abe8',
  packageName: 'com.tencent.news',
  downloadUrl: `http://dldir1.qq.com/dlomg/inews/TencentNews_11589.apk`,
  appleStoreId: '399363156',
  appName: '腾讯新闻--百万现金红包派发中...',
  downLogo: 'https://mat1.gtimg.com/news/news/logo.png'
}
